import { Input, TwDropdown as Dropdown } from '@ui-component-library';
import type { Section, EditData } from './types';

type EditTabProps = {
    section: Section;
    editData: EditData;
    setEditData: (data: EditData) => void;
    setFooterError: (error: string | null) => void;
};

export function EditTab({
    section,
    editData,
    setEditData,
    setFooterError,
}: EditTabProps) {

    const handleInputChange = (field: keyof EditData) => (value: string) => {
        setEditData({ ...editData, [field]: value });
        setFooterError(null);
    };

    const handleDropdownChange = (field: keyof EditData) => (value: string, isValid: boolean) => {
        if (isValid) {
            setEditData({ ...editData, [field]: value });
            setFooterError(null);
        }
    };

    return (
        <div className="flex flex-wrap w-full p-4 bg-cloud-200">
            <Input
                variant="fluid"
                name="localID"
                label="Avd. nr"
                className="mb-2"
                value={editData?.localID ? editData.localID : section?.localID}
                onChange={handleInputChange('localID')}
            />
            <Dropdown
                name="felling_class"
                variant="fluid"
                label="Huggningsklass"
                placeholder="Huggningsklass"
                className="[&>div>div]:rounded-lg-alt [&>div>div]:border-charcoal-alpha-50 [&>div>div]:border-1 [&>div>div]:border-solid [&>div>div]:bg-white-50"
                options={[
                    { label: 'K', value: 'K' },
                    { label: 'R', value: 'R' },
                    { label: 'G1', value: 'G1' },
                    { label: 'G2', value: 'G2' },
                    { label: 'S1', value: 'S1' },
                    { label: 'S2', value: 'S2' },
                    { label: 'S3', value: 'S3' },
                    { label: 'K1', value: 'K1' },
                    { label: 'K2', value: 'K2' },
                    { label: 'R1', value: 'R1' },
                    { label: 'R2', value: 'R2' },
                    { label: 'IA', value: 'IA' },
                    { label: 'NS', value: 'NS' },
                ]}
                value={editData?.felling_class ? editData.felling_class : section.felling_class}
                onChange={handleDropdownChange('felling_class')}
                description=""
                onFocus={() => { }}
            />
            <Input
                variant="fluid"
                name="volume"
                label="Volym"
                className="mb-2"
                value={editData.hasOwnProperty("volume") ? String(editData.volume ?? '') : String(section?.volume ?? '')}
                onChange={handleInputChange('volume')}
                suffix={"m³sk"}
            />
            <Input
                variant="fluid"
                name="tall"
                label="Tall %"
                className="mb-2"
                value={editData.hasOwnProperty("tall") ? String(editData.tall ?? '') : String(section?.tall ?? '')}
                onChange={handleInputChange('tall')}
                suffix={"%"}
            />
            <Input
                variant="fluid"
                name="gran"
                label="Gran %"
                className="mb-2"
                value={editData.hasOwnProperty("gran") ? String(editData.gran ?? '') : String(section?.gran ?? '')}
                onChange={handleInputChange('gran')}
                suffix={"%"}
            />
            <Input
                variant="fluid"
                name="lov"
                label="Löv %"
                className="mb-2"
                value={editData.hasOwnProperty("lov") ? String(editData.lov ?? '') : String(section?.lov ?? '')}
                onChange={handleInputChange('lov')}
                suffix={"%"}
            />
            <Input
                variant="fluid"
                name="age"
                label="Ålder"
                className="mb-2"
                value={editData.hasOwnProperty("age") ? String(editData.age ?? '') : (section?.age ? String(section.age) : '')}
                onChange={handleInputChange('age')}
                suffix={"år"}
            />
            <Dropdown
                name="si"
                variant="fluid"
                label="Ståndortsindex"
                placeholder="ståndortsindex"
                className="[&>div>div]:rounded-lg-alt [&>div>div]:border-charcoal-alpha-50 [&>div>div]:border-1 [&>div>div]:border-solid [&>div>div]:bg-white-50"
                options={
                    Array.from({ length: 33 }, (_, i) => {
                        const v = String(14 + i);
                        return { label: v, value: v };
                    })}
                value={editData.hasOwnProperty("si") ? editData.si : section.si}
                onChange={handleDropdownChange('si')}
                description=""
                onFocus={() => { }}
            />
            <Input
                variant="fluid"
                name="height"
                label="Medelhöjd"
                className="mb-2"
                value={editData.hasOwnProperty("height") ? String(editData.height ?? '') : String(section?.height ?? '')}
                onChange={handleInputChange('height')}
                suffix={"m"}
            />
            <Input
                variant="fluid"
                name="diameter"
                label="Medeldiameter"
                className="mb-2"
                value={editData.hasOwnProperty("diameter") ? String(editData.diameter ?? '') : String(section?.diameter ?? '')}
                onChange={handleInputChange('diameter')}
            />
            <Input
                variant="fluid"
                name="grun"
                label="Grundyta"
                className="mb-2"
                value={editData.hasOwnProperty("grun") ? String(editData.grun ?? '') : String(section?.grun ?? '')}
                onChange={handleInputChange('grun')}
                suffix={"m2"}
            />
        </div>
    );
}
